import React, { useState, useMemo } from 'react'
import { useSelector } from 'react-redux'

import Grid from '@material-ui/core/Grid'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

import { Tooltip, Fab, InputAdornment, IconButton, InputBase } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'

// import EditIcon from '@material-ui/icons/Edit'

import { truncateText } from '../../../../utils'

/**
 * Returns user management forms
 */
const UserMgmtListUsers = (props) => {
  const { handleNewSwap, handleBatchSwap, handleEditSwap, usersInfo, classes } = props

  const [searchVal, setSearchVal] = useState('')
  const [userPermissions, setUserPermissions] = useState([])

  const permissions = useSelector(state => state.auth.permissions)

  useMemo(() => {
    if (permissions.length) setUserPermissions(permissions)
  }, [permissions])

  const canEdit = userPermissions.findIndex((permission) => permission === 'supervisor-editor') !== -1

  return (
    <>
      <Grid container direction='column'>

        <Grid container item direction='row' justify='center' spacing={2} className='mx-auto w-100 my-auto'>
          <Grid item xs={6}>
            <h2 className='my-auto'>
              Supervisor Manager
            </h2>
          </Grid>

          <Grid item xs={6} container direction='row' justify='flex-end'>
            <Grid item>
              {/* <SearchBar id='userSearch' name='userSearch' /> */}
            </Grid>
          </Grid>
        </Grid>

        <Grid container item direction='row' justify='flex-start' spacing={2} className='mx-auto w-100 my-3'>
          <Grid item xs={6} container direction='row' spacing={2} className='my-auto'>
            <Grid item className='py-0'>
              <Button size='large' variant='contained' className={classes.greenBtn} onClick={handleNewSwap} disabled={!canEdit}>
                Create New User
              </Button>
            </Grid>
            <Grid item className='py-0'>
              <Button size='large' variant='contained' onClick={handleBatchSwap} disabled={!canEdit}>Batch Upload</Button>
            </Grid>
          </Grid>

          <Grid item xs={6} container direction='row'>
            <div className={classes.search}>
              <div className={classes.searchIcon}>
                <Fab
                  className={classes.searchBtn}
                  size='small'
                >
                  <SearchIcon />
                </Fab>
              </div>
              <InputBase
                placeholder='John Doe... Manager... john@doe.com'
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput
                }}
                inputProps={{ 'aria-label': 'search' }}
                onChange={(e) => {
                  setSearchVal(e.target.value)
                }}
                value={searchVal}
                endAdornment={
                  searchVal !== ''
                    ? (
                      <InputAdornment position='start'>
                        <IconButton onClick={() => setSearchVal('')}>
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    ) : (<></>)
                }
              />
            </div>
          </Grid>
        </Grid>

        <Grid container item direction='row' justify='center' className={classes.supervisorContainer}>
          <Grid container item direction='column' spacing={3} className='mx-auto w-100'>
            {usersInfo.filter((userInfo) => {
              return `${userInfo.firstName} ${userInfo.lastName}`.toLowerCase().includes(searchVal.toLowerCase()) ||
                userInfo.role.toLowerCase().includes(searchVal.toLowerCase()) ||
                userInfo.emailAddress.toLowerCase().includes(searchVal.toLowerCase())
            }).map((userInfo, i) => (
              <Grid item container direction='row' key={`user-${i}`} className='mx-auto w-100'>
                <Card raised className={classes.userCard}>
                  <CardContent>
                    <Grid container direction='row' alignItems='center' spacing={2} className='w-100 mx-auto'>
                      <Grid item xs={3} container direction='row' alignContent='center'>
                        <Typography className='text-primary font-weight-bold' variant='h6'>
                          {userInfo.lastName}, {userInfo.firstName}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography className='text-break text-muted'>{userInfo.role}</Typography>
                      </Grid>
                      <Grid item xs={3} container direction='row'>
                        {
                          userInfo.emailAddress.length > 23
                            ? (
                              <Tooltip title={userInfo.emailAddress} placement='top'>
                                <Typography variant='caption' className='w-100 text-break'>{truncateText(userInfo.emailAddress, 20)}</Typography>
                              </Tooltip>
                            ) : (
                              <Typography variant='caption' className='w-100 text-break'>{userInfo.emailAddress}</Typography>
                            )
                        }

                      </Grid>
                      <Grid item xs={2} container direction='row' justify='flex-end'>
                        <Button
                          variant='contained'
                          className={classes.greenBtn}
                          onClick={() => handleEditSwap(userInfo)}
                          disabled={!canEdit}
                        >
                          <span className='font-weight-bold'>Edit</span>
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>

      </Grid>
    </>
  )
}

export default UserMgmtListUsers
